import classNames from 'classnames';
import { useMemo } from 'react';
import MEMBERSHIP_OFFERED_ITEMS from '../../../../utils/membership';
import EditIconSvg from '../../../../global/SvgComponents/EditIcon_svg';
import { Button } from '../../../../global/Button';
import { RECYCLING_PRODUCT_TYPES } from '../../../../utils/tbbRegistration';
import { useMembershipOrderTbbContext } from '../../MembershipOrderTbbContext';

import './OrderItemsPreview.scss';

const OrderItemsPreview = ({
  selectedItems,
  onEditClick,
  className,
  renderSummary,
}) => {
  const { isOneTimeOrder } = useMembershipOrderTbbContext();

  const itemsWithQuantity = useMemo(
    () => Object.values(MEMBERSHIP_OFFERED_ITEMS).filter(
      item => item.id !== (
        isOneTimeOrder ? RECYCLING_PRODUCT_TYPES.VIRTUAL : RECYCLING_PRODUCT_TYPES.TECH
      ),
    )
      .map((item) => ({
        ...item,
        quantity: selectedItems[item.id] || 0,
      })),
    [selectedItems, isOneTimeOrder],
  );

  return (
    <div className={classNames('OrderItemsPreview', className)}>
      <Button
        className="OrderItemsPreview__edit-button"
        onClick={onEditClick}
      >
        <EditIconSvg width={20} height={20} />
      </Button>

      <div className="OrderItemsPreview__items">
        {itemsWithQuantity.map((item) => (
          <div key={item.id} className="OrderItemsPreview__item">
            <div className="OrderItemsPreview__item-image-container">
              <img
                src={item.image}
                alt={item.title}
                className="OrderItemsPreview__item-image"
                style={item.imageStyles}
              />
              <div className="OrderItemsPreview__item-quantity">
                <div className="OrderItemsPreview__quantity-badge">
                  {item.quantity}
                </div>
              </div>
            </div>

            <div className="OrderItemsPreview__item-content">
              <div className="OrderItemsPreview__item-title">
                {item.title}
              </div>
              {item.descriptionItems && (
                <ul className="OrderItemsPreview__item-content--description-items">
                  {item.descriptionItems.map((descriptionItem) => (
                    <li className="OrderItemsPreview__item-content--description-items--item" key={descriptionItem}>{descriptionItem}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
      {typeof renderSummary === 'function' && renderSummary()}
    </div>
  );
};

export default OrderItemsPreview;
